import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getGmailCallbackResponse } from 'api/gmail'
import { Toast as toast } from 'components/ui'
import { qkBaseGmail } from 'constants/QueryKeys/gmail'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import strings from 'l10n'

const GmailCallback = () => {
  const queryClient = useQueryClient()
  const json = window.location.search
  const navigate = useNavigate()

  const { mutate } = useMutation({
    mutationFn: () => {
      return getGmailCallbackResponse({ url: json })
    },
    onSuccess: () => {
      toast({
        type: 'success',
        subTitle: strings.GMAIL_AUTHORIZATION_SUCCESS,
      })
      queryClient.invalidateQueries(qkBaseGmail)
      navigate('/settings/adminSettings')
    },
    onError: (error: any) => {
      const message = error?.response?.data?.message || strings.GMAIL_AUTHORIZATION_FAILED
      toast({
        type: 'warning',
        subTitle: message,
      })
      navigate('/settings/adminSettings')
    },
  })

  useEffect(() => {
    mutate()
  }, [mutate])

  return <></>
}

export default GmailCallback
